import 'reflect-metadata'

import { Expose } from 'class-transformer'

export class Blind {
  @Expose()
  public small: number
  @Expose()
  public big: number

  constructor(big: number) {
    this.big = big
    this.small = Blind.smallFromBig(big)
  }

  smallIsHalfBig(): boolean {
    if (this.big % 2 === 0) {
      return this.big / 2 === this.small
    }
    return Math.floor(this.big / 2) === this.small
  }

  static smallFromBig(bigBlind: number) {
    return Math.floor(bigBlind / 2)
  }
}
